import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { CookieService } from 'ngx-cookie-service';
import { isBrowser } from './isBrowser';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent extends isBrowser implements OnInit {
	title = 'Gen-AI-Solution';

	constructor(
		private router: Router,
		private ccService: NgcCookieConsentService,
		private cookieService: CookieService,
		@Inject(PLATFORM_ID) platformId: object
	) {
		super(platformId);
	}

	ngOnInit() {
		if (this.isBrowser) {
			const userDecision = localStorage.getItem('cookie-consent-decision');

			if (!userDecision) {
				this.router.events.subscribe((event) => {
					if (event instanceof NavigationEnd && !this.ccService.hasConsented() && !localStorage.getItem('cookie-consent-decision')) {
						this.ccService.open();
					}
				});
			} else {
			}

			this.ccService.statusChange$.subscribe((event) => {
				if (event.status === 'allow') {
					localStorage.setItem('cookie-consent-decision', 'allow');
				} else if (event.status === 'deny') {
					localStorage.setItem('cookie-consent-decision', 'deny');
				}
			});
		}
	}
}
